import styled from 'styled-components';

const ChipGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export { ChipGroup };
